import React from 'react';
import styles from '../layout/AdminLayout.module.css';

const AdminPostManagementComponent: React.FC = () => {
  return (
    <div className={styles.pageContainer}>
      <div>
        <h1 className={styles.pageTitle}>관리자 게시글 관리</h1>
      </div>
      
      <div className={styles.pageContent}>
        <p>관리자 게시글 관리 기능을 구현해주세요.</p>
      </div>
    </div>
  );
};

export default AdminPostManagementComponent;
